var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDwellTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_14532_170777)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 55,
    height: 56,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 12.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1046 49.6046C48.0072 51.7027 45.3347 53.1316 42.4252 53.7106C39.5156 54.2897 36.4997 53.9928 33.7589 52.8576C31.018 51.7224 28.6754 49.7999 27.0273 47.3332C25.3792 44.8665 24.4997 41.9664 24.5 38.9998H26.375C26.3754 41.5951 27.1453 44.132 28.5874 46.2898C30.0295 48.4475 32.079 50.1292 34.4769 51.1222C36.8747 52.1152 39.5131 52.3749 42.0585 51.8685C44.6039 51.3621 46.942 50.1123 48.7772 48.2771C50.6123 46.442 51.8621 44.1039 52.3685 41.5585C52.8749 39.0131 52.6152 36.3746 51.6222 33.9768C50.6292 31.579 48.9475 29.5295 46.7897 28.0874C44.632 26.6453 42.0951 25.8754 39.4998 25.875V30.9724H37.6248V24H39.4998C42.4664 23.9997 45.3665 24.8792 47.8332 26.5272C50.3 28.1753 52.2225 30.5179 53.3577 33.2588C54.4929 35.9997 54.7898 39.0156 54.2107 41.9252C53.6317 44.8348 52.2027 47.5072 50.1046 49.6046V49.6046ZM42.8267 38.7994C42.8267 39.7953 42.4311 40.7503 41.7269 41.4545C41.0228 42.1586 40.0677 42.5542 39.0719 42.5542C38.0761 42.5542 37.1211 42.1586 36.4169 41.4545C35.7128 40.7503 35.3172 39.7953 35.3172 38.7994C35.3172 38.7767 35.3234 38.7558 35.3238 38.7332L26.375 36.2174L26.8825 34.42L35.8296 36.9377C36.2385 36.2187 36.874 35.6555 37.6367 35.3358C38.3995 35.0162 39.2467 34.9582 40.046 35.1708C40.8452 35.3835 41.5515 35.8549 42.0546 36.5113C42.5577 37.1678 42.8292 37.9724 42.8267 38.7994V38.7994ZM41.0767 38.7994C41.0767 38.403 40.9591 38.0154 40.7388 37.6857C40.5185 37.356 40.2054 37.0991 39.8391 36.9474C39.4728 36.7956 39.0697 36.7559 38.6808 36.8333C38.2919 36.9106 37.9347 37.1016 37.6543 37.3819C37.374 37.6623 37.183 38.0195 37.1057 38.4084C37.0283 38.7973 37.068 39.2004 37.2198 39.5667C37.3715 39.933 37.6284 40.2461 37.9581 40.4664C38.2878 40.6867 38.6754 40.8043 39.0718 40.8043C39.6034 40.8037 40.113 40.5923 40.4888 40.2164C40.8647 39.8406 41.0761 39.331 41.0767 38.7994V38.7994Z",
    fill: "#FF8027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_14532_170777",
    x: 0,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14532_170777"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_14532_170777",
    result: "effect2_dropShadow_14532_170777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_14532_170777",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwellTime);
export default __webpack_public_path__ + "static/media/dwell-time.26d89b9de5bfb169b3eda172c546e320.svg";
export { ForwardRef as ReactComponent };